// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  gaTag: "G-VFQQ04X4C7",
  //apiUrl: "http://localhost/new_excursion/excursion/api/",
  //apiUrl: "http://127.0.0.1:8000/new_excursion/excursion/api/",
  //apiUrl: "http://3.217.253.77/new_excursion/excursion/api/",
  //apiUrl: "http://150.242.13.88/new_excursion/excursion/api/",
  //apiUrl: "http://103.248.60.114/new_excursion/excursion/api/",
  //apiUrl: "http://localhost/new_excursion/excursion/api/",
  //apiUrl: "http://150.242.13.125:9092/",
  //apiUrl: "http://103.248.60.221/new_excursion/excursion/api/",
  //apiUrl:"https://erp.mayratours.org/new_excursion/excursion/api/",
  apiUrl: "https://royaladventureb2b.com/new_excursion/excursion/api/",
  //apiUrl: "https://travelsaga.net/new_excursion/excursion/api/", // travel saga
  appClient:"RoyalAdventure", // Mayra or TravelSaga Or RoyalPark Or RoyalAdventure
  defaultSupplier: [],
  baseAppName: "ExcursionsUI" //"ExcursionsUI"
};

/*

Default Suppliers:
Mayra : ["E/000001"]
TravelSaga : ["E/000041","T-000001"]
RoyalAdventure : []
RoyalPark : []

*/

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
